<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="home">
    <NavBar class="navbar" />
    <div class="container h-100">
      <div class="row">
        <div class="home-content col-12 col-md-8 offset-md-3 offset-xl-2 justify-content-end">
          <div>
            <h1 class="title">L'explorêve</h1>
            <p class="presentation">
              L’Explorêve, c'est un grand jeu virtuel pour les jeunes scouts, guides, éclaireuses et éclaireurs. Il est
              pensé pour des jeunes de 11 ans et plus, mais peut être joué par qui le souhaite !
            </p>
          </div>
          <div class="buttons">
            <b-button variant="secondary" class="px-5" @click="$router.push('/immersion01')"
              >Commencer depuis le début</b-button
            >
            <p class="mb-0 mt-2">
              Sélectionne une immersion pour y jouer
            </p>
            <div style="margin: 20px; gap: 0.5rem;" class="d-flex flex-wrap">
              <b-button variant="light" size="lg" @click="$router.push('/immersion01/1')">Immersion 1</b-button>
              <b-button variant="light" size="lg" @click="$router.push('/immersion02/1')">Immersion 2</b-button>
              <b-button variant="light" size="lg" @click="$router.push('/immersion03/1')">Immersion 3</b-button>
              <b-button variant="light" size="lg" @click="$router.push('/immersion04/1')">Immersion 4</b-button>
            </div>
            <FinishedList></FinishedList>
          </div>
          <NewsletterForm class="mt-5 home-newsletter" />
        </div>
      </div>
    </div>
    <div class="parallax ballon ballon_rouge" data-depth="2" data-X="60" data-Y="12">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_rouge.svg" alt="ballon songe rouge" />
    </div>
    <div class="parallax ballon ballon_vert" data-depth="-2" data-X="-3" data-Y="5">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_vert.svg" alt="ballon songe vert" />
    </div>
    <div class="parallax ballon ballon_violet" data-depth="1" data-X="10" data-Y="80">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_violet.svg" alt="ballon songe violet" />
    </div>
    <div class="parallax ballon ballon_rose" data-depth="-2" data-X="50" data-Y="80">
      <img src="https://cdn.exploreve.fr/content/ballons/ballon_rose.svg" alt="ballon songe rose" />
    </div>

    <div class="parallax nuage n01" data-depth="-1" data-X="50" data-Y="-5"></div>
    <div class="parallax nuage n02" data-depth="-2" data-X="80" data-Y="-5"></div>
    <div class="parallax nuage n03" data-depth="1" data-X="15" data-Y="10"></div>
    <div class="parallax nuage n04" data-depth="-3" data-X="20" data-Y="90"></div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import NewsletterForm from "@/components/NewsletterForm.vue";
import FinishedList from "@/components/FinishedList.vue";

export default {
  data() {
    return {
      code: "",
      nameState: null,
      delta: { x: 0, y: 0 },
      parallax: []
    };
  },
  components: {
    NavBar,
    NewsletterForm,
    FinishedList
  },
  mounted() {
    this.parallax = document.getElementsByClassName("parallax");
    for (let i = 0; i < this.parallax.length; i++) {
      this.parallax[i].setAttribute("parallaxX", 0);
      this.parallax[i].setAttribute("parallaxY", 0);
    }

    window.addEventListener("mousemove", (event) => {
      this.delta.y = event.clientX / window.innerWidth - 0.5;
      this.delta.x = event.clientY / window.innerHeight - 0.5;

      this.loop();
    });
  },
  methods: {
    loop: function () {
      for (let i = 0; i < this.parallax.length; i++) {
        let parX = parseFloat(this.parallax[i].getAttribute("parallaxX"));
        let parY = parseFloat(this.parallax[i].getAttribute("parallaxY"));
        let dept = this.parallax[i].getAttribute("data-depth");
        let posX = this.parallax[i].getAttribute("data-X");
        let posY = this.parallax[i].getAttribute("data-Y");

        parX += ((this.delta.x / dept) * 100 - parX) * 0.2;
        parY += ((this.delta.y / dept) * 100 - parY) * 0.2;

        this.parallax[i].setAttribute("parallaxX", parX);
        this.parallax[i].setAttribute("parallaxY", parY);
        this.parallax[i].style.top = "calc(" + posX.toString() + "% + " + parX.toString() + "px)";
        this.parallax[i].style.left = "calc(" + posY.toString() + "% + " + parY.toString() + "px)";
      }
    },
    isImmersion01Finished: function () {
      return window.localStorage.getItem("immersion01_finished") === "yes";
    }
  }
};
</script>

<style lang="scss" scoped>
#scene {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0%;
  background-color: blue;
}

.home {
  position: relative;
  min-height: 100vh;
  text-align: left;

  &-content {
    z-index: 2;
    h1.title {
      font-size: 80px !important;
      font-style: normal;
      font-weight: bold;
      margin-top: 80px !important;
      margin-bottom: 40px;
    }
    .presentation {
      font-size: 22px;
    }
  }
  .buttons {
    margin-top: 50px;
    margin-bottom: 30px;
    font-size: 1.1em;

    button {
      height: 48px;
      font-size: 1.1em;
    }

    @media screen and (min-width: $breakpoint-lg) {
      .btn-continuer {
        margin-left: 1rem;
      }
    }

    @media screen and (min-width: $breakpoint-sm) {
      font-size: 1.2em;
    }
  }
  form {
    .form-control.is-invalid {
      background-image: none;
      padding-right: 16px;
    }
  }

  a {
    text-decoration: none !important;
  }

  &-newsletter {
    border-top: 1px solid rgba($grey, 0.1);
    padding-top: 1em;
    margin-top: 30px;
  }
}

@media screen and (max-width: $breakpoint-md - 1px) {
  .home-content {
    margin-top: 60px;
  }

  .ballon,
  .nuage {
    display: none;
  }
  .home {
    &-content {
      h1.title {
        font-size: 48px !important;
      }
      p {
        font-size: 18px;
        margin-bottom: 60px;
      }
    }
    .buttons {
      a {
        margin-bottom: 20px;
      }
    }
  }
}

.ballon {
  position: fixed;
}

.navbar {
  position: fixed;
  z-index: 99;
  width: 100%;
}

@media screen and (max-width: $breakpoint-xl) {
  .ballon_violet {
    top: -100px;
    right: 0;
  }

  .ballon_rose {
    bottom: -500px;
    right: -200px;
  }
}

.nuage {
  background-color: $light;
  opacity: 0.7;
  position: fixed;
}

@keyframes float {
  from {
    margin-top: 0;
  }
  to {
    margin-top: 20px;
  }
}

$animation-duration: 3s;

.n01 {
  position: absolute;
  top: 50%;
  left: -5%;
  width: 350px;
  height: 40px;
  border-radius: 20px;
  z-index: 10;
  animation: float $animation-duration infinite alternate ease-in-out;
}

.n02 {
  top: 80%;
  left: -5%;
  width: 600px;
  height: 120px;
  border-radius: 60px;
  z-index: 0;
  animation: float $animation-duration 0.6s infinite alternate ease-in-out;
}

.n03 {
  top: 15%;
  left: 10%;
  width: 400px;
  height: 100px;
  border-radius: 50px;
  z-index: 0;
  animation: float $animation-duration 0.9s infinite alternate ease-in-out;
}

.n04 {
  top: 20%;
  right: 2%;
  width: 300px;
  height: 40px;
  border-radius: 20px;
  z-index: 5;
  animation: float $animation-duration 0.3s infinite alternate ease-in-out;
}

.home-content {
  border-radius: 0px 0px 10px 10px;
  padding-bottom: 10px;
}

.ballon_vert {
  top: -3%;
  left: 5%;
  img {
    height: 600px;
  }
  z-index: 2;
  animation: float $animation-duration 1.2s infinite alternate ease-in-out;
}

.ballon_rouge {
  top: 60%;
  left: 12%;
  img {
    height: 300px;
  }
  z-index: 1;
  animation: float $animation-duration 1.1s infinite alternate ease-in-out;
}

.ballon_violet {
  top: 10%;
  left: 80%;
  img {
    height: 400px;
  }
  z-index: 1;
  animation: float $animation-duration 0.5s infinite alternate ease-in-out;
}

.ballon_rose {
  top: 50%;
  left: 80%;
  img {
    height: 900px;
  }
  z-index: 2;
  animation: float $animation-duration 0.8s infinite alternate ease-in-out;
}
</style>
